import { Component, OnInit } from '@angular/core';
import { SettingsService } from "../../../services/shared/settings.service";
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { RecoverPassword } from '@app/models/password-recovery/recover-password';
import { ActivatedRoute, Router } from '@angular/router';
import { PasswordRecoveryService } from '@app/services/password-recovery/password-recovery.service';
import { CheckRecoveryToken } from '@app/models/password-recovery/check-recovery-token.model';
import {CustomValidators} from "@narik/custom-validators";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  public isTokenUsable: boolean = false;
  public isPasswordChanged: boolean = false;
  public isPasswordChangeRequestSent: boolean = false;
  public valForm: FormGroup;
  public passwordForm: FormGroup;

  constructor(
    public settings: SettingsService,
    fb: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private passwordRecoveryService: PasswordRecoveryService) {

    let password = new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]{6,10}$')]);
    let certainPassword = new FormControl('', CustomValidators.equalTo(password));

    this.passwordForm = fb.group({
      'password': password,
      'confirmPassword': certainPassword
    });

    this.valForm = fb.group({
      'passwordGroup': this.passwordForm
    });
  }

  public submitForm($ev, value: any) {
    $ev.preventDefault();
    for (let c in this.valForm.controls) {
      this.valForm.controls[c].markAsTouched();
    }
    for (let c in this.passwordForm.controls) {
      this.passwordForm.controls[c].markAsTouched();
    }

    if (this.isTokenUsable && this.valForm.valid) {
      this.isPasswordChangeRequestSent = true;
      const model: RecoverPassword = Object.assign({ token: this.activatedRoute.snapshot.queryParamMap.get('token') }, this.passwordForm.value);

      this.passwordRecoveryService.recoverPassword(model).subscribe(
        () => {
          this.isPasswordChanged = true;
        },
        () => {
          this.isPasswordChanged = false;
          this.isPasswordChangeRequestSent = false;
        }
      );
    }
  }

  public ngOnInit() {
    const model: CheckRecoveryToken = { token: this.activatedRoute.snapshot.queryParamMap.get('token') };
    if (model.token == null) {
      this.router.navigate(['/']);
    }


    this.passwordRecoveryService.checkRecoveryToken(model).subscribe(
      (result) => {
        this.isTokenUsable = result;
      },
      () => { this.isTokenUsable = false; }
    );
  }

}
